/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RespondToAppraisal201ResponseData } from './RespondToAppraisal201ResponseData';
import {
    RespondToAppraisal201ResponseDataFromJSON,
    RespondToAppraisal201ResponseDataFromJSONTyped,
    RespondToAppraisal201ResponseDataToJSON,
    RespondToAppraisal201ResponseDataToJSONTyped,
} from './RespondToAppraisal201ResponseData';

/**
 * 
 * @export
 * @interface RespondToAppraisal201Response
 */
export interface RespondToAppraisal201Response {
    /**
     * 
     * @type {boolean}
     * @memberof RespondToAppraisal201Response
     */
    success?: boolean;
    /**
     * 
     * @type {RespondToAppraisal201ResponseData}
     * @memberof RespondToAppraisal201Response
     */
    data?: RespondToAppraisal201ResponseData;
}

/**
 * Check if a given object implements the RespondToAppraisal201Response interface.
 */
export function instanceOfRespondToAppraisal201Response(value: object): value is RespondToAppraisal201Response {
    return true;
}

export function RespondToAppraisal201ResponseFromJSON(json: any): RespondToAppraisal201Response {
    return RespondToAppraisal201ResponseFromJSONTyped(json, false);
}

export function RespondToAppraisal201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RespondToAppraisal201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'data': json['data'] == null ? undefined : RespondToAppraisal201ResponseDataFromJSON(json['data']),
    };
}

export function RespondToAppraisal201ResponseToJSON(json: any): RespondToAppraisal201Response {
    return RespondToAppraisal201ResponseToJSONTyped(json, false);
}

export function RespondToAppraisal201ResponseToJSONTyped(value?: RespondToAppraisal201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'data': RespondToAppraisal201ResponseDataToJSON(value['data']),
    };
}

